import { type ReactNode } from 'react';
import { Button, Menu, MenuTrigger, MenuPopover, MenuList } from '@coreai/fluentui-react';
import { MoreHorizontal20Regular } from '@fluentui/react-icons';

export interface RowActionsMenuProps {
  /** MenuItem nodes rendered inside the popover. */
  children: ReactNode;
  /** Accessible label for the trigger button. */
  ariaLabel: string;
}

/**
 * ⋯ kebab trigger that opens a menu of row actions. Shared by Apps and
 * Workflows tables so every row has a consistent overflow affordance.
 */
export const RowActionsMenu = ({ children, ariaLabel }: RowActionsMenuProps) => (
  <Menu>
    <MenuTrigger disableButtonEnhancement>
      <Button
        appearance="subtle"
        size="small"
        icon={<MoreHorizontal20Regular />}
        aria-label={ariaLabel}
      />
    </MenuTrigger>
    <MenuPopover>
      <MenuList>{children}</MenuList>
    </MenuPopover>
  </Menu>
);
